// extracted by mini-css-extract-plugin
export var loadingSpinner = "_u-0";
export var spinnerContainer = "_u-1";